<template>
  <b-input-group>
    <b-form-input
      :id="id"
      :value="prettyString"
      type="text"
      readonly
    ></b-form-input>
    <b-input-group-append>
      <b-button
        v-if="!readonly"
        size=""
        class=""
        variant="primary"
        @click="edit"
      >
        <Icon2 icon="edit" />
        Edit
      </b-button>
    </b-input-group-append>

    <b-modal
      ref="modal"
      :title="`Edit ${$helpers.prettify(fieldName)}`"
      size="md"
      ok-only
      @ok="updateSchedule"
    >
      <b-button
        size=""
        class=""
        :variant="isSet ? 'danger' : 'warning'"
        :pressed.sync="isSet"
        >{{ isSet ? "Unset" : "Set" }}</b-button
      >

      <div class="d-flex justify-content-center mt-3" v-if="isSet">
        <b-card :title="$helpers.prettify(fieldName)">
          <div class="d-flex align-items-center">
            <b-calendar
              v-model="dateString"
              class="mr-2 mt-3"
              hide-header
            ></b-calendar>
          </div>
        </b-card>
      </div>
    </b-modal>
  </b-input-group>
</template>

<script>
export default {
  name: "DatePicker",

  data() {
    return {
      dateString: "",
    };
  },

  props: {
    id: String,
    value: String,
    readonly: { type: Boolean, default: false },
    fieldName: { type: String, default: "property" },
  },

  watch: {
    value(val) {
      this.dateString = this.$_.clone(val);
    },
  },

  computed: {
    isSet: {
      get() {
        return !!this.dateString;
      },

      set(val) {
        if (val) {
          const now = this.$dt.local();
          this.dateString = now.toFormat("yyyy-MM-dd");
        } else {
          this.dateString = "";
        }
      },
    },

    prettyString() {
      if (!this.dateString) {
        return `No ${this.$helpers.prettify(this.fieldName)}`;
      } else {
        const date = new Date(this.dateString).toLocaleString().split(",");
        return date[0];
      }
    },
  },

  methods: {
    edit() {
      this.dateString = this.value;
      this.$refs.modal.show();
    },

    updateSchedule() {
      if (this.dateString != "") {
        this.$emit("input", this.dateString);
      } else {
        this.$emit("input", null);
      }
    },
  },

  created() {
    this.dateString = this.$_.clone(this.value);
  },
};
</script>

<style scoped></style>
